<template>
  <div :class="['cenario-cabecalho', { 'cenario-minimiza': !mostraCamposCenario }]">
    <div class="cenario-bloco">
      <p>Nome do Cenário:</p>
      <div class="cenario-nome">
        <CenarioInput
          :readonly="!mostraCamposCenario"
          tipo="texto"
          maxlength="100"
          nome="nomeCenario"
          :validaCampos="validaCampos"
          :exibeValidacao="exibeValidacao"
          :model="nomeCenario"
          @update:model="update => calculaDados(update, 'nomeCenario')"
        />
        <BotaoPadrao
          v-if="blUsuarioPro"
          :ref="`carregarCenario`"
          v-show="mostraCamposCenario"
          arredondadoDireita
          class="botao-padding"
          nome="Carregar Cenário"
          cor="azul"
          tooltip="Opção desabilitada na versão de testes"
          desabilita
        />
        <BotaoPadrao
          v-else
          :ref="`carregarCenario`"
          v-show="mostraCamposCenario"
          arredondadoDireita
          class="botao-padding"
          nome="Carregar Cenário"
          :click="handleClickCenarios"
          cor="azul"
        />
      </div>
    </div>
    <div class="cenario-bloco">
      <p>Lista de NCMs:</p>
      <CenarioInput
        :readonly="!mostraCamposCenario"
        placeholder="Selecione uma NCM"
        nome="ncm"
        :validaCampos="validaCampos"
        :exibeValidacao="exibeValidacao"
        :model="ncm"
        :options="listaNcm.map(p => p.label)"
        @update:model="update => (ncm = update)"
        @selected="update => updateDados(update, 'ncm', listaNcm)"
      />
    </div>
  </div>
</template>

<script>
import CenarioInput from "../CenarioInput/CenarioInput.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";

import { mapGetters, mapActions } from "vuex";

export default {
  name: "CenarioCabecalho",

  components: { CenarioInput, BotaoPadrao },

  props: {
    calculaDadosForm: Function,
    calculaDados: Function,
    id: Number,
    numeroCenarios: Number,
    nomeCenario: String,
    ncmLabel: String,
    dadosForm: Object,
    listaNcm: Array,
    validaCampos: Object,
    mostraCamposCenario: Boolean,
    exibeValidacao: Boolean
  },

  data() {
    return {
      ncm: ""
    };
  },

  created() {
    this.carregaDadosForm();
  },

  watch: {
    // CARREGA DADOS QUANDO ALTERADO FORMULÁRIO
    dadosForm: {
      deep: true,
      handler() {
        this.carregaDadosForm();
      }
    },
    // COLOCA FOCO NO BOTÃO DE CARREGAR CENÁRIO PARA 1 CENÁRIO
    blShow() {
      if (this.blShow == false && this.numeroCenarios == 1) {
        let ref = "carregarCenario";
        let referencia = this.$refs[ref];
        referencia.$children[1].$el.focus();
      }
    }
  },

  computed: {
    ...mapGetters("modal", {
      blShow: "getModalListaCenarios"
    }),
    ...mapGetters("auth", {
      blUsuarioPro: "getUsuarioPro"
    }),
  },

  methods: {
    ...mapActions("modal", ["setModalListaCenarios"]),
    // ABRE MODAL DE CENÁRIOS SALVOS
    handleClickCenarios() {
      this.$nextTick(() => {
        this.setModalListaCenarios({ id: this.id, modal: true, ncm: null });
        this.$root.$emit("bv::show::modal", "ModalListaCenarios");
      });
    },
    // ATUALIZA DADOS DO CENÁRIO
    updateDados(update, campo, caminho) {
      this[campo] = update;
      let valor = caminho.find(p => p.label == update);
      this.calculaDadosForm(valor ? valor.value : "", campo);
      this.calculaDados(update, "ncmLabel");
    },
    // ATUALIZA DADOS DO FORMULÁRIO
    carregaDadosForm() {
      let dados = [{ valor: "ncm", filtro: this.listaNcm }];
      dados.forEach(p => {
        this.carregaValor(p.valor, p.filtro);
      });
    },
    // ATUALIZA VALOR LOCAL DE ACORDO COM O FORMULÁRIO
    carregaValor(valor, filtro) {
      let ex = this.dadosForm.ex ? this.dadosForm.ex : "0";
      let resultado = filtro.find(p => p.value == this.dadosForm[valor] && p.ex == ex);
      this[valor] = resultado ? resultado.label : "";
    }
  }
};
</script>

<style lang="scss" scoped>
.cenario-cabecalho {
  border-radius: 10px 10px 0 0;
  background: var(--cinza03);
  border: 1px solid var(--cinza-borda);
  padding: 0.5rem 1.5rem;
}
.cenario-minimiza {
  border-radius: 10px;
  padding-bottom: 20px;
}
p {
  margin: 0;
}
.cenario-bloco {
  width: 100%;
  margin-top: 10px;
  &:first-child {
    margin-top: 0;
  }
}
.botao-carrega-cenario {
  border-radius: 0 50px 50px 0;
  margin-left: 10px;
  padding: 3px 10px;
  background: var(--azul4);
  color: var(--branco);
  white-space: nowrap;
  transition: background 0.3s ease;
  &:hover {
    text-decoration: none;
    background: var(--azul2);
  }
  &:focus {
    background: #25beff;
  }
}
.cenario-nome {
  display: flex;
}
</style>
